import { Controller } from "@hotwired/stimulus";
import { debounce } from "lodash-es";

export default class SubNavigationController extends Controller<HTMLElement> {
  static targets = ["navItem"];
  private isTooltipsInitialized: boolean = false;

  declare readonly navItemTargets: HTMLElement[];

  connect() {
    if (this.isMinimized()) {
      this.initTooltips();
      return;
    }

    this.windowResizeEvent();
    window.addEventListener("resize", this.windowResizeEvent);
  }

  disconnect() {
    window.removeEventListener("resize", this.windowResizeEvent);
  }

  private initTooltips() {
    if (this.isTooltipsInitialized) return;

    this.isTooltipsInitialized = true;
    this.navItemTargets.forEach((item) => {
      $(item).tooltip({
        container: "body",
        title: item.textContent,
        placement: "right",
        template: `
            <div class="tooltip tooltip--variant-light tooltip--gap-large" role="tooltip">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-inner"></div>
            </div>`,
      });
    });
  }

  private destroyTooltips() {
    this.navItemTargets.forEach((item) => {
      $(item).tooltip("destroy");
    });

    this.isTooltipsInitialized = false;
  }

  private isMinimized(): boolean {
    return this.element.classList.contains("sub-navigation--minimized");
  }

  private windowResizeEvent = debounce(() => {
    if (this.isMinimized()) {
      return;
    }

    if (window.innerWidth <= 990 && window.innerWidth > 480) {
      this.initTooltips();
    } else {
      this.destroyTooltips();
    }
  }, 200);
}
